import TransactionsTable from "./Components/TransactinsTable";
import DashboardHeroSection from "./Components/DashboardHeroSection";

export function Dashboard() {
  return (
    <>
      <DashboardHeroSection />
      <TransactionsTable />
    </>
  );
}
